import React from 'react'
import { GasSummary } from '../components'
import { ClockIconSvg } from '../../../assets/svg'

const GasReviewStep = ({
  actionText,
  selectedToken,
  amount,
  isShielding,
  shieldEstimate,
  shieldEstimateLoading,
  shieldEstimateError,
  unshieldEstimate,
  unshieldEstimateLoading,
  unshieldEstimateError
}) => {
  return (
    <>
      {/* Step Description */}
      <div
        className="card mb-3"
      >
        <div className='card-body p-3'>
          <h6 className="fw-bold mb-2 d-flex align-items-center gap-2">
            <ClockIconSvg width={20} height={20} />
            Review Gas Fees & Transaction Details
          </h6>
          <p className="small mb-0">
            Review the estimated gas fees for this transaction. Gas fees vary based on
            network congestion and are paid in{' '}
            {selectedToken?.network === 'ethereum' ? 'ETH' : 'MATIC'}.
          </p>
        </div>
      </div>

      {/* Transaction Amount Summary */}
      <div className="mb-3 py-3 rounded">
        <div className="d-flex justify-content-between align-items-center mb-2">
          <span className="">Amount to {actionText}:</span>
          <span className="fw-bold text-primary">
            {amount} {selectedToken?.symbol}
          </span>
        </div>
        <div className="d-flex justify-content-between align-items-center">
          <span className="">Token:</span>
          <span className="fw-semibold text-primary">{selectedToken?.name}</span>
        </div>
      </div>

      {/* Gas Estimate */}
      <GasSummary
        isShielding={isShielding}
        gasEstimate={isShielding ? shieldEstimate : unshieldEstimate}
        loading={isShielding ? shieldEstimateLoading : unshieldEstimateLoading}
        error={isShielding ? shieldEstimateError : unshieldEstimateError}
      />
    </>
  )
}

export default GasReviewStep
